import { GoogleOAuthProvider } from "@react-oauth/google";
import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import {
  Link,
  Redirect,
  Route,
  Router,
  Switch,
  useLocation,
} from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "./components/@vuexy/spinner/Loading-spinner";
import { routes } from "./component_route/Index";
import { history } from "./history";
import storageService from "./services/storageServices";
import { ContextLayout } from "./utility/context/Layout";
import Profile from "./views/pages/profile/Profile";
import NotificationPopup from "./views/pages/notification_popup/NotificationPopup";
import PaymentReminderPopup from "./views/pages/NEWDASHBOARD/paymentReminderPopup/PaymentReminderPopup";
import BookingsCountPopup from "./views/pages/NEWDASHBOARD/BookingsCountPopup/BookingsCountPopup";
import Rateplans from "./views/pages/NEWDASHBOARD/rateplans/Rateplans";

const AccountDeletion = lazy(() =>
  import("./views/pages/NEWDASHBOARD/accountDeletion/accountDeletion")
);

const Taxes = lazy(() => import("./views/pages/NEWDASHBOARD/taxes/Taxes"));
const NearByLocation = lazy(() =>
  import("./views/pages/NEWDASHBOARD/nearByLocation/NearByLocation")
);
const WalkinBooking = lazy(() =>
  import("./views/pages/NEWDASHBOARD/WalkinBooking/WalkinBooking")
);

// Route-based code splitting
const Home = lazy(() => import("./views/pages/Home"));

const login = lazy(() => import("./views/pages/authentication/login/Login"));
const Scraper = lazy(() =>
  import("./views/pages/NEWDASHBOARD/Scraper/Scraper")
);
const forgotPassword = lazy(() =>
  import("./views/pages/authentication/managePassword/ForgotPassword")
);

const recoverPassword = lazy(() =>
  import("./views/pages/authentication/managePassword/RecoverPassword")
);

const Analytics = lazy(() => import("./views/pages/analytics/index"));
const BookingDetails = lazy(() =>
  import("./views/pages/analytics/BookingDetails")
);
const Users = lazy(() => import("./views/pages/users/index"));

const Social = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/SocialMedia/SocialMedia")
);

const PaymentConfig = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/PaymentConfiguration/PaymentConfig")
);

const Report = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/Report/Report")
);

const AddStaff = lazy(() =>
  import("./views/pages/NEWDASHBOARD/addStaff/AddStaff")
);

const AddLogo = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/AddLogo/AddLogo")
);

const FAQ = lazy(() => import("./views/pages/NEWDASHBOARD/manage/FAQ/FAQ"));
const AddFAQ = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/FAQ/AddFaq")
);

const Promotion = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/Promotion/Promotion")
);

const Promotions = lazy(() =>
  import("./views/pages/NEWDASHBOARD/promotions/promotions.component")
);

const InventoryManagement = lazy(() =>
  import("./views/pages/NEWDASHBOARD/inventory_management/InventoryManagement")
);

const HouseRules = lazy(() =>
  import("./views/pages/NEWDASHBOARD/policy/HouseRules/HouseRules")
);

const CancellationPolicy = lazy(() =>
  import(
    "./views/pages/NEWDASHBOARD/policy/CancellationPolicy/CancellationPolicy"
  )
);

const Terms = lazy(() => import("./views/pages/terms-conditions/Terms"));

const Addons = lazy(() => import("./views/pages/NEWDASHBOARD/addons/Addons"));
const AddonsList = lazy(() =>
  import("./views/pages/NEWDASHBOARD/addons/AddonList")
);
const EditAddon = lazy(() =>
  import("./views/pages/NEWDASHBOARD/addons/EditAddon")
);

const GAds = lazy(() => import("./views/pages/NEWDASHBOARD/gads/GoogleAds"));

const AddProperty = lazy(() =>
  import("./views/pages/NEWDASHBOARD/onboarding/StepBased")
);

const ImageClassifier = lazy(() =>
  import("./views/pages/NEWDASHBOARD/allImage/AllImage")
);
const HotelImage = lazy(() =>
  import("./views/pages/NEWDASHBOARD/allImage/HotelImage")
);

const Step1 = lazy(() => import("./views/pages/NEWDASHBOARD/onboarding/Step1"));

const Settlements = lazy(() =>
  import("./views/pages/NEWDASHBOARD/settlements/Settlements")
);

const MyBusiness = lazy(() =>
  import("./views/pages/NEWDASHBOARD/gmb/MyBusiness")
);

const AdSummary = lazy(() =>
  import("./views/pages/NEWDASHBOARD/newAds/AdSummary")
);

const RoomList = lazy(() =>
  import("./views/pages/NEWDASHBOARD/rooms/RoomList")
);

const AddRoom = lazy(() => import("./views/pages/NEWDASHBOARD/rooms/AddRoom"));

const UpdateProperty = lazy(() =>
  import("./views/pages/NEWDASHBOARD/onboarding/UpdateProperty")
);

const Leads = lazy(() => import("./views/pages/NEWDASHBOARD/Leads/Leads"));

const BookingPref = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/BookingPreference/index")
);

const Domain = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/Domain/Domain")
);

const GoogleReviews = lazy(() =>
  import("./views/pages/NEWDASHBOARD/manage/GoogleReviews/GoogleReviews")
);

const Post = lazy(() => import("./views/pages/NEWDASHBOARD/Post/Post"));

const Scrape = lazy(() => import("./views/pages/NEWDASHBOARD/scrape/Scrape"));

const PersonalInfo = lazy(() =>
  import("./views/pages/NEWDASHBOARD/personal_info/PersonalInfo")
);
const AccountSettings = lazy(() =>
  import("./views/pages/NEWDASHBOARD/accountSettings/AccountSettings")
);

// const AdCreate = lazy(() =>
//   import("./views/pages/NEWDASHBOARD/socialAds/CampaignCreation")
// );
const Invoices = lazy(() =>
  import("./views/pages/NEWDASHBOARD/invoices/Invoices")
);

const RevenueManagement = lazy(() =>
  import(
    "./views/pages/NEWDASHBOARD/revenueManagement/RevenueManagement.component"
  )
);

const SocialAds = lazy(() =>
  import("./views/pages/NEWDASHBOARD/newAds/NewAds")
);

const CampaignCreationPage = lazy(() =>
  import("./views/pages/NEWDASHBOARD/newAds/CampaignCreationPage")
);

const ChannelManager = lazy(() =>
  import("./views/pages/NEWDASHBOARD/channelManager/ChannelManager")
);

const CustomWebsite = lazy(() =>
  import("./views/pages/NEWDASHBOARD/custom_website/CustomWebsite")
);

const HouseKeeping = lazy(() =>
  import("./views/pages/NEWDASHBOARD/HouseKeeping/HouseKeeping")
);

// Set Layout and Component Using App Route
const RouteConfig = ({
  component: Component,
  fullLayout,
  permission,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <ContextLayout.Consumer>
          {(context) => {
            let LayoutTag =
              fullLayout === true
                ? context.fullLayout
                : context.state.activeLayout === "horizontal"
                ? context.horizontalLayout
                : context.VerticalLayout;
            return (
              <LayoutTag {...props} permission={props.user}>
                <Suspense fallback={<Spinner />}>
                  {/* <GoogleOAuthProvider clientId="12635238179-btgd3hed91iu39a4u71b191q55d1cqis.apps.googleusercontent.com"> */}
                  <GoogleOAuthProvider clientId="1015179130342-4pgm5utr027sgtfojibehq3gje6imhdl.apps.googleusercontent.com">
                    <Component {...props} />
                  </GoogleOAuthProvider>
                </Suspense>
              </LayoutTag>
            );
          }}
        </ContextLayout.Consumer>
      );
    }}
  />
);
const mapStateToProps = (state) => {
  return {
    user: state.auth.userRole,
  };
};

const AppRoute = connect(mapStateToProps)(RouteConfig);

const ProtectedRoute = (props) => {
  const { path, component, ...rest } = props;
  const user = storageService.get("userAdmin");

  return user ? (
    <AppRoute path={path} component={component} {...rest} />
  ) : (
    <Redirect
      to={{
        pathname: routes.login,
        state: { to: props.location?.pathname },
      }}
    />
  );
};

class AppRouter extends React.Component {
  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={history}>
        <Switch>
          <AppRoute path={routes.login} component={login} fullLayout />
          <AppRoute
            path={routes.forgotPassword}
            component={forgotPassword}
            fullLayout
          />
          <AppRoute
            path={routes.recoverPassword}
            component={recoverPassword}
            fullLayout
          />
          {/* <AppRoute path={routes.terms} component={Terms} fullLayout /> */}
          <AppRoute path={routes.terms} component={Terms} fullLayout />
          <AppRoute path={routes.terms1} component={Terms} fullLayout />

          {/* <ProtectedRoute exact path={routes.home} component={Analytics} /> */}
          <ProtectedRoute exact path={routes.home} component={Home} />
          <ProtectedRoute exact path={routes.scraper} component={Scraper} />
          {/* <ProtectedRoute exact path={routes.socialAds} component={SocialAds} /> */}
          {/* <ProtectedRoute
            exact
            path={"/create-campaign/:id"}
            component={AdCreate}
          /> */}
          {/* <ProtectedRoute exact path={routes.aiCampEdit} component={AdCreate} /> */}
          {/* <ProtectedRoute path={routes.settings} component={settings} />
          <ProtectedRoute path={routes.dashboard} component={dashboard} />
          <ProtectedRoute path={routes.volume} component={volume} />
          <ProtectedRoute path={routes.customers} component={customer} />
          <ProtectedRoute path={routes.kyc} component={kyc} />
          <ProtectedRoute path={routes.walletTopup} component={walletTopup} />
          <ProtectedRoute
            path={routes.transactionHistory}
            component={transactionHistory}
          />
          <ProtectedRoute path={routes.withdrawal} component={withdrawal} />
          <ProtectedRoute path={routes.payee} component={payee} />
          <ProtectedRoute
            path={routes.transactionStatus}
            component={transactionStatus}
          />
          <ProtectedRoute path={routes.ticket} component={ticket} />
          <ProtectedRoute path={routes.feedback} component={feedback} />
          <ProtectedRoute exact path={routes.banner} component={banner} />
          <ProtectedRoute
            path={routes.urgentAnnouncement}
            component={urgentAnnouncement}
          />
          <ProtectedRoute path={routes.appConfig} component={appConfig} />
          <ProtectedRoute
            path={routes.complyAdvantage}
            component={complyAdvantage}
          />
          <ProtectedRoute path={routes.rejectReason} component={rejectReason} />
          <ProtectedRoute path={routes.apayloMail} component={apaylo} />
          <ProtectedRoute
            path={routes.apayloTransaction}
            component={apayloTransaction}
          />
          <ProtectedRoute path={routes.moreDetails} component={moreDetails} />
          <ProtectedRoute path={routes.manageAdmin} component={manageAdmin} />
          <ProtectedRoute path={routes.auditLogs} component={auditLogs} />
          <ProtectedRoute
            path={routes.manageDepositWorkflow}
            component={manageDepositWorkflow}
          /> */}
          <ProtectedRoute path={routes.users} component={Users} />
          <ProtectedRoute path={routes.socialAds} component={SocialAds} />
          <ProtectedRoute
            path={routes.campaignCreation}
            component={CampaignCreationPage}
          />
          <ProtectedRoute path={routes.bookings} component={Analytics} />
          <ProtectedRoute
            path={routes.bookingDetails}
            component={BookingDetails}
          />
          <ProtectedRoute path={routes.social} component={Social} />
          <ProtectedRoute
            path={routes.paymentConfig}
            component={PaymentConfig}
          />
          <ProtectedRoute path={routes.addLogo} component={AddLogo} />
          <ProtectedRoute path={routes.campaigns} component={AdSummary} />
          <ProtectedRoute
            path={routes.inventoryManagement}
            component={InventoryManagement}
          />
          <ProtectedRoute path={routes.report} component={Report} />
          <ProtectedRoute path={routes.addStaff} component={AddStaff} />
          <ProtectedRoute path={routes.faq} component={FAQ} />
          <ProtectedRoute path={routes.addFaq} component={AddFAQ} />
          <ProtectedRoute path={routes.promo} component={Promotions} />
          <ProtectedRoute path={routes.houseRules} component={HouseRules} />
          <ProtectedRoute path={routes.addHotelAddons} component={Addons} />
          <ProtectedRoute path={routes.hotelAddons} component={AddonsList} />
          <ProtectedRoute path={routes.editHotelAddons} component={EditAddon} />
          <ProtectedRoute path={routes.gads} component={GAds} />
          <ProtectedRoute path={routes.domain} component={Domain} />
          <ProtectedRoute
            path={routes.customWebsite}
            component={CustomWebsite}
          />
          <ProtectedRoute
            path={routes.cancellationPolicy}
            component={CancellationPolicy}
          />
          <ProtectedRoute path={routes.allImage} component={ImageClassifier} />
          <ProtectedRoute path={routes.hotelImage} component={HotelImage} />
          <ProtectedRoute
            path={routes.addProperty}
            fullLayout
            component={AddProperty}
          />
          <ProtectedRoute path={routes.step1} fullLayout component={Step1} />
          <ProtectedRoute path={routes.settlements} component={Settlements} />
          <ProtectedRoute path={routes.gmb} component={MyBusiness} />
          <ProtectedRoute path={routes.rooms} component={RoomList} />
          <ProtectedRoute path={routes.addRoom} component={AddRoom} />
          <ProtectedRoute path={routes.leads} component={Leads} />
          <ProtectedRoute
            path={routes.bookingPreference}
            component={BookingPref}
          />
          <ProtectedRoute
            path={routes.updateProperty}
            component={UpdateProperty}
          />
          <ProtectedRoute
            path={routes.googleReviews}
            component={GoogleReviews}
          />
          <ProtectedRoute path={routes.profile} component={Profile} />
          <ProtectedRoute path={routes.post} component={Post} />
          <ProtectedRoute path={routes.scrape} component={Scrape} />
          <ProtectedRoute path={routes.personalInfo} component={PersonalInfo} />
          <ProtectedRoute
            path={routes.accountSettings}
            component={AccountSettings}
          />
          <ProtectedRoute path={routes.invoices} component={Invoices} />
          <ProtectedRoute
            path={routes.revenueManagement}
            component={RevenueManagement}
          />
          <ProtectedRoute
            path={routes.channelManager}
            component={ChannelManager}
          />
          <ProtectedRoute
            path={routes.requestAccountDeletion}
            component={AccountDeletion}
          />
          <ProtectedRoute path={routes.taxes} component={Taxes} />
          <ProtectedRoute path={routes.rateplans} component={Rateplans} />
          <ProtectedRoute
            path={routes.nearByLocation}
            component={NearByLocation}
          />
          <ProtectedRoute
            path={routes.walkinBooking}
            component={WalkinBooking}
          />
          <ProtectedRoute
            path={routes.requestAccountDeletion}
            component={AccountDeletion}
          />
          <ProtectedRoute path={routes.houseKeeping} component={HouseKeeping} />
        </Switch>
        <ToastContainer
          autoClose={3000}
          position="top-right"
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <NotificationPopup />
        <PaymentReminderPopup />

        <BookingsCountPopup />

        {/* <ProtectedRoute path={routes.taxes} component={Taxes} /> */}
      </Router>
    );
  }
}

export default AppRouter;
